<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка салатов</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Салаты – самый легкий перекус, который помогает восстановить силы или просто может быть прекрасным дополнением к основному блюду во время обеда или ужина.</p>
            <p>На сайте <router-link to="/">хочу-поесть.рф</router-link> есть вкусные салаты из ресторанов вашего города. Вы сможете найти Ваш любимый салат в меню на сайте и сразу сделать заказ с  доставкой домой или в офис.</p>
            <p>Закажи салат с курицей, салат с сыром, говядиной, грабами, морепродуктами или любой другой. На Ваш вкус! Удобней и вкусней с заказом еды через сайт <router-link to="/">хочу-поесть.рф</router-link>.</p>
            <p>При выборе салатов вы дополнительно можете заказать горячее блюдо или маленький десерт для поднятия настроения на весь день!</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/salad1.jpg" alt="Доставка салатов" width="700" /></center></p>
            <p style="margin-top:2%;">Не забудьте, наш кулинарный портал открыт для тех, кто любит готовить. Лучшие повара всей страны собрали для Вас оригинальные рецепты салатов и многих других блюд, которые Вы с легкостью приготовите у себя дома.</p>
            <router-link :to="'/product/6'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'salad'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/salad.vue